

module.exports = __webpack_require__.stylable.create(
    "Popup168148732",
    {"classes":{"root":"Popup168148732__root","wrapper":"Popup168148732__wrapper","box":"Popup168148732__box","button":"Popup168148732__button"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "Popup168148732",
    null
);
